import React from "react";
import { InfiniteScroll } from "../../nq-component";
import BasePage from "../../base/BasePage";
import PageHeader from "../../components/PageHeader";
import withRouter from "../../withRouter";
import ProfilePage from "./ProfilePage";

class ProfileStandalonePage extends BasePage {
  render() {
    return (
      <InfiniteScroll className="p-3 p-xl-4 overflow-auto">
        <div className="d-flex flex-column gap-4">
          <PageHeader
            breadcrumb={[
              { label: "Home", path: "/" },
              { label: "Profile" },
            ]}
            title="Profile"
            backButton
            list={true}
            description="View your profile information"
          />
          <div
            className="bg-white rounded-3 shadow-sm"
            style={{ border: "1px solid #e9ecef" }}
          >
            <ProfilePage />
          </div>
        </div>
      </InfiniteScroll>
    );
  }
}

export default withRouter(ProfileStandalonePage);
